import React from 'react';

const DetailModal: React.FC<{ title?: string; open: boolean; onClose: () => void; children?: React.ReactNode }> = ({ title, open, onClose, children }) => {
  if (!open) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 1050,
        }}
        onClick={onClose}
      />
      {/* Modal Container */}
      <div
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          zIndex: 1051,
          width: '90%',
          maxWidth: '800px',
          maxHeight: '90vh',
          overflowY: 'auto',
          backgroundColor: 'white',
          borderRadius: '12px',
          boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1), 0 10px 10px -5px rgba(0,0,0,0.04)',
        }}
      >
        <div className="modal-header" style={{ padding: '1rem', borderBottom: '1px solid #e5e7eb' }}>
          <h5 className="modal-title" style={{ margin: 0 }}>{title || 'Details'}</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onClose}
            style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}
          >
            ×
          </button>
        </div>
        <div className="modal-body" style={{ padding: '1rem' }}>
          {children}
        </div>
        <div className="modal-footer" style={{ padding: '1rem', borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end' }}>
          <button className="btn btn-secondary" onClick={onClose} style={{ padding: '0.5rem 1rem' }}>
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default DetailModal;